<template>
  <div v-if="showInfo">
    Message Sent! If necessary, one of our representatives will be in contact
    with you soon. You may close this window.
  </div>
  <div v-if="showErr">Something went wrong, please try again later.</div>
  <form v-if="!showInfo && !showErr" @submit.prevent="send()">
    <div class="content" style="padding: 0; margin: 0">
      <loader :loading="loading"></loader>
      <!-- <span class="close" @click="close()"></span> -->
      <h4>College Partnerships</h4>
      <status-component />
      <p>
        If you represent a college or university and would like to offer NSSI
        programs as an option for your students, fill out the form below.
      </p>
      <br />
      <div class="fieldleft">
        <label class="tinylabel">Full Name <red v-pre>*</red></label
        ><input v-model="partnership.fullName" type="text" />
      </div>
      <div class="fieldright">
        <label class="tinylabel">Title <red v-pre>*</red></label
        ><input v-model="partnership.title" type="text" />
      </div>
      <div class="fieldleft">
        <label class="tinylabel">Email <red v-pre>*</red></label
        ><input v-model="partnership.email" type="text" />
      </div>
      <div class="fieldright">
        <label class="tinylabel">Phone <red v-pre>*</red></label
        ><input v-model="partnership.phone" type="text" />
      </div>
      <div class="fieldleft">
        <label class="tinylabel">College / University <red v-pre>*</red></label
        ><input v-model="partnership.college" type="text" />
      </div>
      <div class="fieldright">
        <label class="tinylabel">City <red v-pre>*</red></label
        ><input v-model="partnership.city" type="text" />
      </div>
      <div class="fieldleft">
        <label class="tinylabel">State <red v-pre>*</red></label
        ><input v-model="partnership.state" type="text" />
      </div>
      <div class="fieldright">
        <label class="tinylabel">Approx. # of Students <red v-pre>*</red></label
        ><input v-model="partnership.nrOfStudents" type="number" min="0" />
      </div>
      <div style="clear: both"></div>
      <div class="field">
        <label class="tinylabel">I am looking for... <red v-pre>*</red></label>

        <input
          id="college-ineed1"
          v-model="partnership.infoGeneral"
          type="checkbox"
          class="styledchecked extraspacecheck"
          name="college-ineed"
          :true-value="true"
        /><label for="college-ineed1">General Information</label><br />
        <input
          id="college-ineed2"
          v-model="partnership.infoPrint"
          type="checkbox"
          class="styledchecked extraspacecheck"
          name="college-ineed"
          :true-value="true"
        /><label for="college-ineed2">Print Materials</label><br />
        <input
          id="college-ineed3"
          v-model="partnership.infoDigital"
          type="checkbox"
          class="styledchecked extraspacecheck"
          name="college-ineed"
          :true-value="true"
        /><label for="college-ineed3">Digital Materials</label><br />
      </div>
      <div style="clear: both"></div>
      <br /><br />
      <div class="field">
        <label class="tinylabel">Comments <red v-pre>*</red></label
        ><textarea v-model="partnership.comments"></textarea>
      </div>
      <div style="clear: both"></div>
      <br /><br />
      <div style="text-align: center">
        <button :disabled="!validate" type="submit">Send</button>
      </div>
    </div>
  </form>
</template>

<script lang="ts" setup>
import { Partnership } from "@/models/Partnership";
import Loader from "@/components/MainLoader.vue";
import { EmailService } from "@/api/EmailService";
import StatusComponent from "@/components/StatusComponent.vue";
import { Ref, ref, ComputedRef, computed } from "vue";
import { useReCaptcha } from "vue-recaptcha-v3";
import { useStatusStore } from "@/stores/root/status";
import { stat } from "@/utils/Utils";

const partnership = ref(new Partnership());
const loading = ref(false);
const captchaResoult: Ref<boolean> = ref(false);
const showInfo = ref(false);
const showErr = ref(false);
const statusStore = useStatusStore();
const gReCaptcha = useReCaptcha();
const recaptcha = async () => {
  // (optional) Wait until recaptcha has been loaded.
  await gReCaptcha?.recaptchaLoaded();

  // Execute reCAPTCHA with action "login".
  const token = await gReCaptcha?.executeRecaptcha("submit");
  if (token) {
    captchaResoult.value = true;
  } else {
    captchaResoult.value = false;
  }
};

/**
 * Validates required fields.
 */
const validate: ComputedRef<boolean> = computed(() => {
  return (
    partnership.value.fullName.length > 0 &&
    partnership.value.title.length > 0 &&
    partnership.value.comments.length > 0 &&
    partnership.value.email.length > 0 &&
    partnership.value.phone.length > 0 &&
    partnership.value.college.length > 0 &&
    partnership.value.city.length > 0 &&
    partnership.value.state.length > 0 &&
    partnership.value.nrOfStudents > 0 &&
    (partnership.value.infoDigital ||
      partnership.value.infoGeneral ||
      partnership.value.infoPrint)
  );
});

/**
 * Checks captcha and send email.
 */
const send = async (): Promise<void> => {
  await recaptcha();
  if (stat(statusStore)) {
    stat(statusStore).clear();
  }

  loading.value = true;
  const sendMail = await EmailService.sendCollegePartnershipInfo(
    partnership.value
  );
  loading.value = false;
  sendMail.error ? (showErr.value = true) : (showInfo.value = true);
};
</script>
